import { LEGAL_DOCUMENT_PAGES, legalTexts } from "../legal/legalDocumentTranslations";
import type { AppShellNavigationFooterProps } from "./AppShellNavigationFooter";

/**
 * Daten für den in allen Apps gleichen Navigations-Fußbereich: Tarifkarte (`planName` = aktueller Tarif,
 * `null` = noch keiner gewählt) und AGB, Datenschutz und Impressum auf der gemeinsamen Rechtsseite
 * (`legal/LegalDocumentPage`, Route `/legal/:page`). Texte in allen Shared-Sprachen.
 */
export function platformNavigationFooter(locale: string, options: {
  pathname: string;
  navigate: (path: string) => void;
  /** Route der Rechtsseite im jeweiligen Rahmen (Standard `/legal`). */
  basePath?: string;
  /** `meta` ersetzt die Zeile „Tarif wechseln/wählen“, z. B. durch das Guthaben in Apps mit Credits. */
  plan?: { planName: string | null; meta?: string; current?: boolean; onClick: () => void };
}): AppShellNavigationFooterProps {
  const { pathname, navigate, plan, basePath = "/legal" } = options;
  const t = legalTexts(locale);
  return {
    plan: plan ? { title: plan.planName ?? t.plan, meta: plan.meta || (plan.planName ? t.changePlan : t.choosePlan), current: plan.current, onClick: plan.onClick } : undefined,
    legal: {
      label: t.legal,
      links: LEGAL_DOCUMENT_PAGES.map((page) => ({ key: page, label: t[page], current: pathname === `${basePath}/${page}`, onClick: () => navigate(`${basePath}/${page}`) })),
    },
  };
}
